import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {
	CheckRelationsObject,
	ConfigurationObject,
	SearchRelationsExObject,
	SearchRelationsObject
} from '../../interfaces/interfaces.regisafe';
import {AppConfig} from '../../app.config';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {UserService} from '../../provider/user/user.service';
import {StorageService} from '../../provider/storage/storage.service';
import {IQApiService} from '../../provider/iqapi/iqapi.service';
import {ModalController} from '@ionic/angular';
import {RelationListComponent} from './relation-list/relation-list.component';
import {APP_ICON_PATH} from '../../../environments/environment';

@Component({
	selector: 'app-regisafe-relations',
	templateUrl: './regisafe-relations.component.html',
	styleUrls: ['./regisafe-relations.component.scss'],
})
export class RegisafeRelationsComponent implements OnInit {

	@ViewChild('popover', {static: true}) popover: HTMLIonPopoverElement;

	@Input() details: object;
	@Input() osId: string;
	@Input() objId: string;

	appIconPath = APP_ICON_PATH;

	public configuration: ConfigurationObject;
	modal: HTMLIonModalElement;
	popoverIsOpen = false;

	relationsArray: Array<any> = [];
	relationsMap = new Map([
		['-', 'Übergeordnete'],
		['*', 'Untergeordnete'],
		['-*', 'Über-/untergeordnete'],
		['=', 'Zugeordnete'],
	]);

	noRelations = [];
	disableRelationsBtn = false;

	constructor(public appConfig: AppConfig,
				private errorHandling: ErrorHandlingService,
				private userService: UserService,
				private storageService: StorageService,
				private iqAPI: IQApiService,
				private modalCtrl: ModalController) {
		this.configuration = this.appConfig.getConfig();
	}

	ngOnInit() {
		this.checkRelations();
	}

	async checkRelations() {
		const body: CheckRelationsObject = {
			apiID: this.configuration.iqapiAppId,
			objID: this.userService.objIdAsIQAPIParam(this.objId),
			osId: this.osId,
			sessionToken: this.storageService.getToken()
		};

		const response = await this.iqAPI.orgaManagerCheckRelations(body)
			.toPromise()
			.catch((errorResponse) => {
				this.errorHandling.handleError(errorResponse, 'DetailPage -> checkRelations');
			});

		Object.keys(response.relations).forEach((key) => {
			const translated = this.storageService.getOsStructNameFromConditionsSync(key);
			if (response.relations[key] !== '') {
				this.relationsArray.push({
					osId: key,
					translatesOrgaStructure: translated,
					relations: this.relationsMap.get(response.relations[key]),
					searchMode: response.relations[key],
					orgastruct: key,
					iconpath: this.userService.getExistingOrgastructIconOrDefault(key)
				});
			} else {
				this.noRelations.push(key);
				this.disableRelationsBtn = this.noRelations.length === Object.keys(response.relations).length;
			}
		});
	}

	async searchRelations(item) {

		const body: SearchRelationsObject = {
			apiID: this.configuration.iqapiAppId,
			dataStores: [],
			objID: this.userService.objIdAsIQAPIParam(this.objId),
			osId: this.osId,
			searchMode: '',
			fields: ['Vorgangskennung', 'Text', 'ADatum', 'Datum'],
			searchOsId: item.osId,
			sessionToken: this.storageService.getToken()
		};

		const response = await this.iqAPI.orgaManagerSearchRelations(body)
			.toPromise()
			.catch((errorResponse) => {
				this.errorHandling.handleError(errorResponse, 'DetailPage -> searchRelations');
			});

		console.log('resonse: ', response);
	}

	async searchRelationsEx(item) {

		const body: SearchRelationsExObject = {
			addosId: 1,
			apiID: this.configuration.iqapiAppId,
			objID: this.userService.objIdAsIQAPIParam(this.objId),
			osId: this.osId,
			searchMode: '',
			searchOsId: item.osId,
			sortFields: 'ADatum<',
			fields: ['Vorgangskennung', 'Text', 'ADatum', 'Datum', '_ObjId'],
			sessionToken: this.storageService.getToken()
		};

		const response = await this.iqAPI.orgaManagerSearchRelationsEx(body)
			.toPromise()
			.catch((errorResponse) => {
				this.errorHandling.handleError(errorResponse, 'DetailPage -> searchRelationsEx');
			});

		if (response) {
			this.popoverIsOpen = false;
			this.openRelationListModal(response, item);
		}

	}

	async openRelationListModal(rel: object, item) {
		this.modal = await this.modalCtrl.create({
			component: RelationListComponent,
			componentProps: {
				relations: rel,
				osId: this.osId,
				meta: item
			},
			backdropDismiss: true
		});

		await this.modal.present();

		return this.modal.onDidDismiss().then((response) => {
			console.log('Lorem: ', response);
		});
	}

	presentPopover(e: Event) {
		this.popover.event = e;
		this.popoverIsOpen = true;
	}



}
